<template>
  <div class="row">
    <div class="col-sm-6 content-wrapper">
      <template v-if="candidate.type === 0">
        <label class="col-sm-12 mb-sm-1">{{ candidate.title }} | Employment</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.company_name }}</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.start_date_formatted }} -
          {{ candidate.end_date_formatted }} | {{ candidate.company_address }}</label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <template v-if="candidate.type === 1">
        <label class="col-sm-12 mb-sm-1">{{ candidate.qualification }} | Education</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.institute }}</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.start_date_formatted }} -
          {{ candidate.end_date_formatted }} | {{ candidate.institute_address }}</label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <template v-if="candidate.type === 2">
        <label class="col-sm-12 mb-sm-1">{{ candidate.name }} | Self-Employment / Trade</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.utr_number }}</label>
        <label class="col-sm-12 mb-sm-1">{{ candidate.start_date_formatted }} -
          {{ candidate.end_date_formatted }} | {{ candidate.address }}</label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <template v-if="candidate.type === 3">
        <label class="col-sm-12 mb-sm-1">Unemployed</label>
        <label class="col-sm-12 mb-sm-1">
          {{ candidate.start_date_formatted }} - {{ candidate.end_date_formatted }}
        </label>
        <label class="col-sm-12 mb-sm-1">{{ calculateDifference(candidate.end_date, candidate.start_date) }}</label>
      </template>
      <customized-comments
          :comment="comment"
          :history="candidate"
          :applicantId="applicantId"
          :statusable_type="statusable_type"
          :statusable_id="statusable_id"
          :emailAddress="emailAddress"
          :steps="this.steps"
      />
    </div>
    <div class="col-sm-6 content-wrapper">
      <h6>
        Action History:
      </h6>
<!--      <div class="form-group row">-->
<!--        <el-button-->
<!--            type="primary"-->
<!--            size="small"-->
<!--            @click="setIsShowStatus">-->
<!--          {{ isShowStatus ? 'Hide Status' : 'Show Status' }}-->
<!--        </el-button>-->
<!--      </div>-->

<!--      <div class="form-group row" v-if="isShowStatus">-->
<!--        <general-comments-->
<!--            :comments="comment"-->
<!--            :emailAddress="emailAddress"-->
<!--            :applicantId="applicantId"-->
<!--            :statusable_type="statusable_type"-->
<!--            :statusable_id="statusable_id"-->
<!--            :steps="this.steps"-->
<!--        />-->
<!--      </div>-->
      <div class="form-group row">
        <comments-steps-tree :steps="steps"
                             :history="candidate"
                             @node-delete="deleteNode"
                             @node-edit="editNode"
        />
        <comments-list v-if="showCommentList"
                       :comment="commentToEdit"
                       :applicantId="applicantId"
                       :emailAddress="emailAddress"
                       @close-comment-listing="closeComment"
                       :steps="this.steps"
        />
      </div>
    </div>
  </div>
</template>

<script>
import {
  calculateDifference,
  dateFormatter
} from "@Views/Screening/utility/common";
import {_status, oralSteps, writtenSteps} from "@Views/Screening/utility/constant";
import {updateCommentSteps} from "@Views/Screening/utility/common/comment";

export default {
  name: "HistoryComments",
  props: {
    candidate: {
      type: Object
    },
    applicantId: {
      type: Number
    },
    statusable_type: {
      type: String
    },
    statusable_id: {
      type: Number
    },
    emailAddress: {
      type: String
    },
    comment: {
      type: Array
    }
  },
  data() {
    return {
      steps: [],
      showCommentList: false,
      commentToEdit: {},
      statusList: _status,
      oralSteps: oralSteps,
      writtenSteps: writtenSteps,
      isShowStatus: false
    }
  },
  created() {
    this.setStepsOnInitialization();
  },

  methods: {
    dateFormatter,
    updateCommentSteps,
    calculateDifference,
    deleteNode(event) {
      const {data} = event.node;
      let index = data.index - 1;
      this.steps.splice(index, 1);
    },
    editNode(event) {
      this.commentToEdit = {};
      this.$set(this.commentToEdit, 'id', event.data.children[0].id);
      this.$set(this.commentToEdit, 'action_comment', event.data.children[0].action_comment);
      this.$set(this.commentToEdit, 'status', event.data.children[0].type);
      this.$set(this.commentToEdit, 'applicant_files', event.data.children[0].applicant_files);
      this.$set(this.commentToEdit, 'statusable_id', event.data.children[0].statusable_id);
      this.$set(this.commentToEdit, 'statusable_type', event.data.children[0].statusable_type);
      this.showCommentList = true;
    },
    closeComment(event) {
      this.commentToEdit = {};
      this.showCommentList = event;
    },
    setStepsOnInitialization() {
      for (const _comment of this.comment) {
        const o = {
          id : _comment.id,
          action_comment: _comment.action_comment,
          include_in_report: _comment.include_in_report,
          status: _comment.status,
          applicant_files: _comment.applicant_files,
          statusable_id : _comment.statusable_id,
          statusable_type : _comment.statusable_type
        };
        this.updateCommentSteps(o, true);
      }
    },
    setIsShowStatus() {
      this.isShowStatus = !this.isShowStatus;
    }
  }
}
</script>

<style scoped></style>